import styled from 'styled-components';

export const NotFoundContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 3.5rem 1rem 2rem;
  max-width: 344px;
  margin: 0 auto;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  color: ${Styles.color.black};

  h1 {
    margin: 0;
    font-family: ${Styles.fontFamily.base};
    font-size: 1.5rem;
    line-height: 2.25rem;
    text-transform: capitalize;
  }

  p {
    margin: 0 0 1.25rem;
    font-size: 1rem;
    line-height: 1.1rem;
  }

  button {
    width: 100%;
    height: 40px;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    line-height: 1rem;
  }

  button + button {
    margin-top: 1rem;
  }
`;
